<template>
  <div class="hello">
      <transition name="fade">
        <div v-if="startingPayment" class="loading">
            <p>Processing Payment</p>
        </div>
    </transition>

    <!-- Modal to show server error -->
    <b-modal no-fade id="modal-servererror" ok-only title="Serve Error" ok-title="OK">
        There was an error contacting our payment servers. Please try again later.  
    </b-modal>

    <!-- Modal to show card error -->
    <b-modal no-fade id="modal-carderror" ok-only title="Error Processing Cart" ok-title="OK">
        Error processing this card. Please check all fields.
    </b-modal>
    <!-- Modal to show payment succesfull -->
    <b-modal no-fade id="modal-paymentsuccessfull" ok-only title="SUCCESS" ok-title="OK">
        Your order has been placed
    </b-modal>

    <b-container>
        <!-- Stripe element -->
        <label>Card</label>
        <div id="card-element" :style="paymentCardStyle"></div>

        <!-- Cart Cost -->
        <b-row style="margin-top:20px">
            <b-col>
                <h4>Total Cost = {{cartCost}}</h4>
            </b-col>
        </b-row>
        <b-row style="margin-top:20px">
            <b-col>
                <h4>Ship and bill to: {{getBillingAddress}}</h4>
            </b-col>
        </b-row>

        
        <!-- Place order button -->
        <b-row style="margin-top:10px">
            <b-col>
                <b-button size="lg" block v-b-modal.modal-submit1 variant='success' @click="startPayment()">Place Order</b-button>
            </b-col>
        </b-row>

        <b-row>
            <b-col>
                <b-button>Apple Pay</b-button>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-button>PayPal</b-button>
            </b-col>
        </b-row>
    </b-container>
    {{consumerCart}}
      
  </div>
</template>

<script>

    import { mapState } from 'vuex'
    import moment from 'moment'
    const fb = require('../../firebaseConfig.js')
    import firebase from 'firebase/app';
    import {incrementbeerinventory} from '../Myfunctions'
    const db = firebase.firestore()
    import axios from 'axios'
    import Pagefooter from '../Pagefooter'
    import {sendnotification} from '../Myfunctions'

export default {    
    props: {
    },

    computed: {
        ...mapState(['userProfileStatus', 'userProfile', 'currentUser', 'cartCost', 'consumerCart']),
        getBillingAddress(){
            var address=''
            for (var i=0; i<this.consumerCart.length; i++){
                address=this.consumerCart[i].billingaddress
            }
            return address
        },  
    },

    components: {
    },

    data() {
        return {
            ordersArray:[],
            creditCardNumber:'',
            expirationData:'',
            cvv:'',
            billingAddress:'',

            stripeAPIToken: 'pk_test_51HGaq6GBZf0U9jAiUjhCfOGITsKiFCzqSCsIIxxDi30G1SxXtQPvTc0eQbi8Ip2HCbwdf3w8NcnhmGhnYozbe9el00xEGnnUC0',
            stripe: '',
            elements: '',
            card: '',
            clientSecret:"",
            paymentCardStyle: {
                base: {
                    color: "#32325d",
                    fontFamily: 'Arial, sans-serif',
                    fontSmoothing: "antialiased",
                    fontSize: "16px",
                    "::placeholder": {
                    color: "#32325d"
                    }
                },
                invalid: {
                    fontFamily: 'Arial, sans-serif',
                    color: "#fa755a",
                    iconColor: "#fa755a"
                }
            },
            startingPayment:false,
            cardPaymentError:false,
            serverError:false,

        }
    },

    methods:{

        startPayment(){
            //Get client secret
            this.startingPayment=true
            this.serverError=false
            this.cardPaymentError=false
            var theURL='https://orderupdates.kegseeker.com:5000/payments'

            var bodyFormData = new FormData();
            bodyFormData.set('amount', (this.cartCost).toFixed(2));
            bodyFormData.set('currency', 'usd');

            axios({
                method: 'post',
                url: theURL,
                data: bodyFormData,
                headers: {'Content-Type': 'multipart/form-data' }
            }).then(response => {
                this.clientSecret = response.data.clientSecret
                this.serverError=false
                this.processPayment()
            })
            .catch(response => {
                //handle server error
                this.serverError=true
                this.startingPayment=false
                this.$bvModal.show("modal-servererror")
                console.log(response);
                return "ERROR"
            });

        },

        processPayment(){
            console.log("Processing payment")
                console.log("Sending to Stripe") 
                this.stripe
                    .confirmCardPayment(this.clientSecret, {
                        receipt_email: this.userProfile.email,
                        payment_method: {
                            card: this.card
                        }
                    })
                    .then(result => {
                        if (result.error) {
                            // Show error to your customer
                            console.log("ERR")
                            console.log(result.error.message)
                            this.cardPaymentError=true
                            this.startingPayment=false
                            this.$bvModal.show("modal-carderror")
                        } else {
                            // The payment succeeded!
                            console.log("SUCCESS")
                            this.cardPaymentError=false
                            this.startingPayment=false
                            this.$bvModal.show("modal-paymentsuccessfull")
                            this.submitOrder(result.paymentIntent.id);
                        }
                });

        },
        showError(message){
            console.log("Stripe error = ")
            console.log(message)
        },
        orderComplete(paymentIntentId){
            console.log("Order complete with intent id = ")
            console.log(paymentIntentId)

        },
        //Submit the orders
        submitOrder(paymentIntentId){
            console.log("Submitting")
            console.log(this.consumerCart)

            console.log("Iterating length = " + this.consumerCart.length)
            //Iterate over all orders
            for (var k=0; k<this.consumerCart.length; k++){
                console.log("k=" + k)
                var theOrder = this.consumerCart[k]
                theOrder.paymentIntentId=paymentIntentId
                
                //Set buyer note
                if(!theOrder.buyerNote) theOrder.buyerNote=""
                //Add only if there are some cart items
                if (theOrder.cartItems.length>0){
                    //Add order to database
                    console.log("Adding")
                    console.log(theOrder)
                    fb.consumerOrdersCollection.add(theOrder)
                    console.log("Added")
                    var brewerId = theOrder.brewerid

                    //Iterate over items for this brewer to update quantity
                    for (var i=0; i<theOrder.cartItems.length; i++){
                        var thisItem = theOrder.cartItems[i]
                        var qty = -1*parseInt(thisItem.orderQuantity)
                        if (thisItem.container =='can'){
                            qty = -1*(thisItem.orderQuantity*thisItem.canConsumerCaseSize/thisItem.cansPerCase).toFixed(2)
                        } 
                        if (thisItem.container =='bottle') qty = -1*(thisItem.orderQuantity*thisItem.bottleConsumerCaseSize/thisItem.bottlesPerCase).toFixed(2)
                        incrementbeerinventory(thisItem.id, qty, thisItem)
                        //Update sold count
                        var incrementBeersSold = firebase.firestore.FieldValue.increment(parseInt(thisItem.orderQuantity));
                        fb.beersCollection.doc(thisItem.docId).update({ soldCount: incrementBeersSold })
                    }

                    //Send notification and email to each brewer
                    var text ="New order from " + this.userProfile.company
                    var subject ="New order from " + this.userProfile.company
                    sendnotification(theOrder.brewerid, text)
                }
            }
            this.$store.commit('emptyCart', [])
            this.$store.commit('emptyConsumerCart', [])
            this.$store.commit('setCartCost', 0)

        },
        includeStripe( URL, callback ){
            let documentTag = document, tag = 'script',
                object = documentTag.createElement(tag),
                scriptTag = documentTag.getElementsByTagName(tag)[0];
            object.src = '//' + URL;
            if (callback) { object.addEventListener('load', function (e) { callback(null, e); }, false); }
            scriptTag.parentNode.insertBefore(object, scriptTag);
        },

        configureStripe(){
            this.stripe = Stripe( this.stripeAPIToken );
            this.elements = this.stripe.elements();
            this.card = this.elements.create('card');
            this.card.mount('#card-element');
        },
    },

    mounted(){
        this.includeStripe('js.stripe.com/v3/', function(){
            this.configureStripe();
            }.bind(this) );
 
    },
}
</script>

